import { categories } from "@/mocks/news";

interface Props {
  onPick: (id: string) => void;
}

export default function Categories({ onPick }: Props) {
  return (
    <section id="cat" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-primary-600">
            <i className="ri-apps-2-line" /> CHANNELS
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            吃瓜分类 · 按你口味追
          </h2>
          <p className="mt-3 text-sm leading-6 text-foreground-500">
            兴趣太杂没关系，按栏目直达你想看的那一趴，点一下即可筛选对应速报。
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => (
            <a
              key={c.id}
              href="#latest"
              onClick={() => onPick(c.id)}
              className="group flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
            >
              <span
                className={
                  "flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-lg text-background-50 " +
                  (i % 3 === 0 ? "bg-primary-500" : i % 3 === 1 ? "bg-accent-500" : "bg-secondary-500")
                }
              >
                <i className={c.icon} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{c.name}</h3>
                  <i className="ri-arrow-right-line text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
                </div>
                <p className="mt-1.5 text-xs leading-5 text-foreground-500">{c.desc}</p>
                <span className="mt-2 inline-block text-[11px] font-semibold text-primary-600">
                  查看该栏目速报 →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}